
// region JS Imports

// region External Modules
import $ from "jquery"
import "plugins/jquery_plugins/bootstrap-carousel"

import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports

const CELL_CLASS_NAME = "cell--buildings--images--carousel"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  const updateItemCount = ($cell: JQuery) => {
    const total_slides = $cell.find(".item").length
    const current_slide = $cell.find(".item.active").data("slide") + 1
    $cell.find(".cell--buildings--images--carousel__item--counter").text(`${current_slide}/${total_slides}`)
  }

  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = $(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    // carousel autoplay recommended to be disabled for web vitals
    // https://web.dev/carousel-best-practices/
    $el.carousel("pause")

    // # Manually initialize buttons, instead of using data attribute
    const $slide_to_prev_button = $el.find(".cell--buildings--images--carousel__slide-to-prev-btn")
    const $slide_to_next_button = $el.find(".cell--buildings--images--carousel__slide-to-next-btn")

    $slide_to_prev_button.on("click", (e) => {
      // # Might be an anchor with hash in href
      e.preventDefault()

      $el.carousel("prev")
    })
    $slide_to_next_button.on("click", (e) => {
      // # Might be an anchor with hash in href
      e.preventDefault()

      $el.carousel("next")
    })

    updateItemCount($el)

    $el.on("slid.bs.carousel", () => {
      updateItemCount($el)
    })
  })
}

export default {init}
